module.exports = __webpack_public_path__ + "static/media/matrix.a07ac74a.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/StateofSocial/matrix.png
// module id = 479
// module chunks = 0